// MyPDFComponent.js
import React, { memo } from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import moment from "moment";
import PropTypes from "prop-types";
import appConfig from "@/config/appConfig";

const defaultLogo = `${window.location.origin}/images/logo.png`;

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
  },
  section: {
    padding: 30,
    flexGrow: 1,
  },
  image: {
    width: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 5,
  },
});

const ReactPDF = memo(({ img, name, updatedAt = new Date(), firstBusiness }) => {
  const logo = firstBusiness?.logo || defaultLogo;
  return (
    <>
      <Document>
        {/*  orientation:"portrait" | "landscape" */}
        <Page size="A4" style={styles.page}>
          {/* header */}
          <View
            render={() => (
              <View style={{ padding: "5px 30px" }}>
                <View style={styles.header}>
                  <Image src={logo} style={{ height: 45, width: 110 }} />
                  <View
                    style={{
                      width: 350,
                      textAlign: "right",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{moment(updatedAt).format("DD/MM/YYYY HH:mm:ss")} </Text>
                    <Text style={{ fontWeight: 900 }}> {name ? name : ""} </Text>
                  </View>
                </View>
                <View style={{ height: 4, backgroundColor: "black" }} />
              </View>
            )}
            fixed
            style={{ textAlign: "center", padding: "10px 0" }}
          ></View>
          <View style={styles.section}>{img ? <Image break={true} src={img} /> : <Text> No data found </Text>}</View>
          <View
            render={() => (
              <>
                <Text style={{ color: "white", fontSize: 10 }}>
                  {firstBusiness?.name ? `© ${firstBusiness?.name} ${new Date().getFullYear()}. All rights reserved` : appConfig.copyright}
                </Text>
              </>
            )}
            fixed
            style={{
              textAlign: "center",
              padding: "10px 0",
              backgroundColor: "black",
              marginTop: 10,
            }}
          />
        </Page>
      </Document>
    </>
  );
});

export default ReactPDF;

ReactPDF.displayName = "ReactPDF";
ReactPDF.propTypes = {
  img: PropTypes.string,
  name: PropTypes.string,
  updatedAt: PropTypes.instanceOf(Date),
  firstBusiness: PropTypes.object,
};
